import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {Link, Route, Switch} from "react-router-dom";


import Home from './Home';
import Service from './Service';
import About from './About';
import Contact from './Contact';

import HomeRoundedIcon from '@material-ui/icons/HomeRounded';
import ContactMailRoundedIcon from '@material-ui/icons/ContactMailRounded';
import SettingsApplicationsRoundedIcon from '@material-ui/icons/SettingsApplicationsRounded';
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';


import tuneItconLogo from '../tuneitcon_logo.png';

//import { HashLink as Link} from "react-router-hash-link";

const drawerWidth = 180;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
        background : '#FFFFFF',
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    logo: {
        maxWidth: 160,
    },
}));

const styles = {
    sideNav: {
        marginTop: '10px',
        zIndex: 300,
        marginLeft: '0px',
        position: 'fixed',
    },
    link: {
        color: 'black',
        textDecoration: 'none',
    }
};

function MainDrawer(props) {
    const { window } = props;
    const classes = useStyles();
    const theme = useTheme();
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawer = (
        <div>
            <div className={classes.toolbar} />
            <Divider />
            <Link to='/home' style={styles.link}>
                <List>
                    <ListItem button key='Home'>
                        <ListItemIcon><HomeRoundedIcon/>
                        </ListItemIcon>
                        <ListItemText primary='Home' />
                    </ListItem>
                </List>
            </Link>
            <Link to='/service' style={styles.link}>
                <List>
                    <ListItem button key='Services'>
                        <ListItemIcon><SettingsApplicationsRoundedIcon/>
                        </ListItemIcon>
                        <ListItemText primary='Services' />
                    </ListItem>
                </List>
            </Link>
            <Link to='/about' style={styles.link}>
                <List>
                    <ListItem button key='About Us'>
                        <ListItemIcon><InfoRoundedIcon/>
                        </ListItemIcon>
                        <ListItemText primary='About Us' />
                    </ListItem>
                </List>
            </Link>
            <Link to='/contact' style={styles.link}>
                <List>
                    <ListItem button key='Contact Us'>
                        <ListItemIcon><ContactMailRoundedIcon/>
                        </ListItemIcon>
                        <ListItemText primary='Contact Us' />
                    </ListItem>
                </List>
            </Link>
        </div>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        className={classes.menuButton}
                    >
                        <MenuIcon />
                    </IconButton>
                    <img src={tuneItconLogo} alt="logo" className={classes.logo} />
                </Toolbar>
            </AppBar>
            <nav className={classes.drawer} aria-label="mailbox folders">
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Hidden smUp implementation="css">
                    <Drawer
                        container={container}
                        variant="temporary"
                        anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
                <Hidden xsDown implementation="css">
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        variant="permanent"
                        open
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
            </nav>
            <main className={classes.content}>
                <div className={classes.toolbar} />
                <Switch>
                    <Route path="/" exact component={Home} />
                    <Route path="/home" exact component={Home} />
                    <Route path="/service" component={Service} />
                    <Route path="/about" component={About} />
                    <Route path="/contact" component={Contact} />
                </Switch>

            </main>
        </div>
    );
}

MainDrawer.propTypes = {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};

export default MainDrawer;